module.exports = __webpack_public_path__ + "img/responsabilidad.e558451b.svg";